import React, { Component } from 'react';
import Analytics from 'components/analytics/Analytics'
import { connect } from 'react-redux'

class AnalyticsContainer extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    window.analytics.page('Analytics')
  }

  render() {
    let bets = this.props.userbets.filter(bet => bet.status !== 1)
    if (bets.length === 0) {
      return (
        <div className='container-fluid'>
          <div className='panel'>
            <header className='panel-heading'>You don't have any bets yet</header>
            <div className='panel-body'>
              <p className='lead'>You don't have any settled bets yet! Come back here once you got some settled bets to see a breakdown of how you're doing!</p>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <Analytics
          user={this.props.user}
          userbets={bets}
          currencies={this.props.currencies}
        />
      </div>
    )
  }
}

export default connect(state => {
  return {
    userbets: state.userbets,
    currencies: state.currencies
  }
})(AnalyticsContainer)



/** WEBPACK FOOTER **
 ** ./src/containers/AnalyticsContainer.js
 **/